var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountBalance = function SvgAccountBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_8511",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_8511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79158 14.1666V7.91664H6.04158V14.1666H4.79158ZM9.37491 14.1666V7.91664H10.6249V14.1666H9.37491ZM2.30762 17.0833V15.8333H17.6922V17.0833H2.30762ZM13.9582 14.1666V7.91664H15.2082V14.1666H13.9582ZM2.30762 6.24997V5.06414L9.99991 1.2981L17.6922 5.06414V6.24997H2.30762ZM5.26262 4.99997H14.7372L9.99991 2.7083L5.26262 4.99997Z",
    fill: "#152A58"
  }))));
};
export default SvgAccountBalance;